import { proxy } from '@/utils'

import { core } from '@/components/services/settingsSite/utils'

import render from './render'

export default function(options) {
  return {
    mixins: [ proxy({ type: 'object' }), core(options) ],

    data() {
      return {
        visibility: {
          tinkoff: {
            Password: false,
            ekamToken: false
          },
          mandarin: {
            secret: false,
            ekamToken: false
          },
          stripe: {
            apikey: false
          }
        }
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
